import L from 'leaflet'
import { createLayerComponent } from '@react-leaflet/core';

const proto_setPos = L.Marker.prototype._setPos;
const LeafletMarker = L.Marker.extend({
    _setRotation(rotation) {
        if (typeof rotation === 'number' && this._icon) {
            const rotateRegExp = /\srotate\(.*\)/;
            const translate3dRegExp = /(^|\s)translate3d\(.*\)/;
            const matrixRegExp = /(^|\s)matrix\(.*\)/;
            const translateValRegExp = /((^|\s)translate3d\()|\)/g;
            this._icon.style[L.DomUtil.TRANSFORM + 'Origin'] = 'center';
            const oldTransform = this._icon.style[L.DomUtil.TRANSFORM];
            const oldTranslateVal = oldTransform
                .replace(translateValRegExp, '')
                .split(', ')
                .map(val => {
                    const s = val.replace('px', '');
                    return parseFloat(s);
                })
            const [x, y, z] = oldTranslateVal;
            const translateVal = [x, y + 18, z]
                .map(num => `${num}px`)
                .join(', ')
            const transform = (oldTransform
                .replace(rotateRegExp, '')
                .replace(translate3dRegExp, '') +
                `translate3d(${translateVal})` + 
                ` rotate(${rotation}deg)`);
            this._icon.style[L.DomUtil.TRANSFORM] = transform
        }
    },
    _setPos(pos) {
        proto_setPos.call(this, pos);
        this._setRotation(this.options.rotation);
    },
    setRotation(rotation) {
        this.options.rotation = rotation;
        this._setRotation(rotation);
    },
})

const createMarker = (props, ctx) => {
    const {position, ...options} = props;
    const instance = new LeafletMarker(position, options);

    return {
        instance,
        context: {...ctx,
            overlayContainer: instance
        }
    };
}
const updateMarker = (marker, props, prevProps) => {
    if (props.position !== prevProps.position) {
        marker.setLatLng(props.position);
    }

    if (props.rotation !== prevProps.rotation) {
        marker.setRotation(props.rotation);
    }
    
    if (props.icon != null && props.icon !== prevProps.icon) {
        marker.setIcon(props.icon);
    }
    
    if (props.zIndexOffset != null && props.zIndexOffset !== prevProps.zIndexOffset) {
        marker.setZIndexOffset(props.zIndexOffset);
    }
    
    if (props.opacity != null && props.opacity !== prevProps.opacity) {
        marker.setOpacity(props.opacity);
    }
    
    if (marker.dragging != null && props.draggable !== prevProps.draggable) {
        if (props.draggable === true) {
            marker.dragging.enable();
        } else {
            marker.dragging.disable();
        }
    }
}

const RotatedMarker = createLayerComponent(createMarker, updateMarker);

export default RotatedMarker